import Layer from './index'
import LayerBase from './LayerBase'
import Item from '../Item'
import { parallaxLayerDimensions, dimensions } from '../../config/settings'
import { GlobalState } from '../../config/globalState'
import { addExtraObjects } from './extraObjectsFactory'

export function createLayers(isLowEnd: boolean): Layer[] {
  const { positionsConfig } = GlobalState

  return positionsConfig.map((_config, i) => {
    const layerIndex = positionsConfig.length - 1 - i
    const layer = new Layer(parallaxLayerDimensions[i], positionsConfig[layerIndex])

    addExtraObjects(layer, positionsConfig[layerIndex], isLowEnd)
    return layer
  })
}

export function createBulletLayers(layers: Layer[]): { bulletLayers: LayerBase[]; items: Item[] } {
  const bulletLayers: LayerBase[] = []
  const items: Item[] = []

  layers.forEach((layer) => {
    // const bulletLayer = new LayerBase(layer.name, layer.size, dimensions)
    layer.items.forEach((item: Item) => {
      items.push(item)
      // bulletLayer.addChild(item.itemBullet)
    })
    // bulletLayer.sortableChildren = true
    // bulletLayers.push(bulletLayer)
  })

  return { bulletLayers, items }
}
